const TUI_DUTCH_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['Nummer', 'Kaartnummer'],
  cardExpiry: ['Vervaldatum', 'Vervaldatum Kaart']
};
const TUI_DUTCH_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['Effen kleur', 'Kleurverloop'],
  toolbarTools: {
    undo: 'Undo',
    redo: 'Redo',
    font: 'Lettertype',
    fontStyle: 'Tekenstijl',
    fontSize: 'Punten',
    bold: 'Vet',
    italic: 'Cursief',
    underline: 'Onderstrepen',
    strikeThrough: 'Doorhalen',
    justify: 'Uitlijning',
    justifyLeft: 'Uitlijning links',
    justifyCenter: 'Uitlijning midden',
    justifyRight: 'Uitlijning rechts',
    justifyFull: 'Uitlijning uitvullen',
    list: 'Lijst',
    indent: 'Inspringen',
    outdent: 'Uitspringen',
    unorderedList: 'Ongesorteerde lijst',
    orderedList: 'Gesorteerde lijst',
    quote: 'Citeren',
    foreColor: 'Kleur',
    backColor: 'Achtergrondkleur',
    hiliteColor: 'Tekstmarkeringskleur',
    clear: 'Wis',
    link: 'Koppeling',
    attach: 'Bestand toevoegen',
    tex: 'TeX toevoegen',
    code: 'Code',
    image: 'Afbeelding toevoegen',
    insertHorizontalRule: 'Horizontale lijn toevoegen',
    superscript: 'Superscript',
    subscript: 'Subscript',
    insertTable: 'Insert table',
    insertGroup: 'Insert group',
    hiliteGroup: 'Hilite group',
    removeGroup: 'Remove group',
    insertAnchor: 'Insert anchor',
    mergeCells: 'Merge cells',
    splitCells: 'Split cells',
    rowsColumnsManaging: 'Managing rows and columns',
    cellColor: 'Cell color',
    setDetails: 'Details',
    removeDetails: 'Remove details'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'anchor'
  },
  editorTableCommands: [['Insert column before', 'Insert column after'], ['Insert row before', 'Insert row after'], ['Delete column', 'Delete row']],
  editorCodeOptions: ['Code in the text', 'Code in block'],
  editorFontOptions: {
    small: 'Small',
    large: 'Large',
    normal: 'Normal',
    title: 'Title',
    subtitle: 'Subtitle'
  }
};
const TUI_DUTCH_LANGUAGE_ADDON_TABLE = {
  showHideText: 'Toon/Verberg',
  paginationTexts: {
    pages: "Pagina's",
    linesPerPage: 'Lijnen per pagina',
    of: 'van'
  }
};
const TUI_DUTCH_LANGUAGE_COUNTRIES = {
  AD: 'Andorra',
  AE: 'Verenigde Arabische Emiraten',
  AF: 'Afghanistan',
  AG: 'Antigua en Barbuda',
  AI: 'Anguilla',
  AL: 'Albanië',
  AM: 'Armenië',
  AO: 'Angola',
  AR: 'Argentinië',
  AT: 'Oostenrijk',
  AU: 'Australië',
  AW: 'Aruba',
  AZ: 'Azerbeidzjan',
  BA: 'Bosnië en Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'België',
  BF: 'Burkina Faso',
  BG: 'Bulgarije',
  BH: 'Bahrein',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'Sankt Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei',
  BO: 'Bolivia',
  BQ: 'Bonaire, Sint Eustatius en Saba',
  BR: 'Brazilië',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BW: 'Botswana',
  BY: 'Wit-Rusland',
  BZ: 'Belize',
  CA: 'Canada',
  CD: 'Dem. Rep. Congo (Kinshasa)',
  CF: 'Centraal-Afrikaanse Republiek',
  CG: 'Congo-Brazzaville',
  CH: 'Zwitserland',
  CI: 'Ivoorkust',
  CL: 'Chili',
  CM: 'Kameroen',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Kaapverdië',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Tsjechië',
  DE: 'Duitsland',
  DJ: 'Djibouti',
  DK: 'Denemarken',
  DM: 'Dominica',
  DO: 'Dominicaanse Republiek',
  DZ: 'Algerije',
  EC: 'Ecuador',
  EE: 'Estland',
  EG: 'Egypte',
  ER: 'Eritrea',
  ES: 'Spanje',
  ET: 'Ethiopië',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Eilanden',
  FM: 'V.S. van Micronesië',
  FR: 'Frankrijk',
  GA: 'Gabon',
  GB: 'Verenigd Koningkrijk',
  GD: 'Grenada',
  GE: 'Georgië',
  GF: 'Guyana',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Groenland',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Equatoriaal-Guinea',
  GR: 'Griekenland',
  GT: 'Guatemala',
  GW: 'Guinee-Bissau',
  GY: 'Guyana',
  HK: 'Hongkong',
  HN: 'Honduras',
  HR: 'Kroatië',
  HT: 'Haïti',
  HU: 'Hongarije',
  ID: 'Indonesië',
  IE: 'Ierland',
  IL: 'Israël',
  IN: 'India',
  IQ: 'Irak',
  IR: 'Iran',
  IS: 'IJsland',
  IT: 'Italië',
  JM: 'Jamaica',
  JO: 'Jordanië',
  JP: 'Japan',
  KE: 'Kenia',
  KG: 'Kirgizië',
  KH: 'Cambodja',
  KM: 'Comoren',
  KN: 'Saint Kitts en Nevis',
  KP: 'Democratische Volksrepubliek Korea',
  KR: 'Republiek Korea',
  KW: 'Koeweit',
  KY: 'Kaaiman Eilanden',
  KZ: 'Kazachstan',
  LA: 'Laos',
  LB: 'Libanon',
  LC: 'Sint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Litouwen',
  LU: 'Luxemburg',
  LV: 'Letland',
  LY: 'Libië',
  MA: 'Marokko',
  MC: 'Monaco',
  MD: 'Moldavië',
  ME: 'Montenegro',
  MF: 'Sankt Martin',
  MG: 'Madagascar',
  MK: 'Rep. van Noord-Macedonië',
  ML: 'Mali',
  MM: 'Birma (Myanmar)',
  MN: 'Mongolië',
  MO: 'Macau',
  MQ: 'Martinique',
  MR: 'Mauritanië',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Maleisië',
  MZ: 'Mozambique',
  NA: 'Namibië',
  NC: 'Nieuw-Caledonië',
  NE: 'Niger',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Nederland',
  NO: 'Noorwegen',
  NP: 'Nepal',
  NZ: 'Nieuw-Zeeland',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'Frans Polynesië (Tahiti)',
  PG: 'Papoea-Nieuw-Guinea',
  PH: 'Filippijnen',
  PK: 'Pakistan',
  PL: 'Polen',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'Besprechung',
  RO: 'Roemenië',
  RS: 'Serbia',
  RU: 'Servië',
  RW: 'Rwanda',
  SA: 'Saoedi-Arabië',
  SB: 'Salomonseilanden',
  SC: 'Seychellen',
  SD: 'Soedan',
  SE: 'Zweden',
  SG: 'Singapore',
  SH: 'Sint-Helena, Ascension en Tristan da Cunha',
  SI: 'Slovenië',
  SK: 'Slowakije',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalië',
  SR: 'Suriname',
  ST: 'Sao Tomé en Principe',
  SV: 'El Salvador',
  SX: 'Sint Maarten',
  SY: 'Arabische Rep. Syrië',
  SZ: 'Swaziland',
  TC: 'Turks- en Caicoseilanden',
  TD: 'Tsjaad',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tadzjikistan',
  TL: 'Oost Timor',
  TM: 'Turkmenistan',
  TN: 'Tunesië',
  TO: 'Tonga',
  TR: 'Turkije',
  TT: 'Trinidad en Tobago',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  UA: 'Oekraïne',
  UG: 'Oeganda',
  US: 'Verenigde Staten',
  UY: 'Uruguay',
  UZ: 'Oezbekistan',
  VC: 'Saint Vincent en de Grenadines',
  VE: 'Venezuela',
  VG: 'Britse Maagdeneilanden',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Jemen',
  YT: 'Mayotte',
  ZA: 'Zuid-Afrika',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AC: 'Ascension Island',
  AS: 'American Samoa',
  AX: 'Åland Islands',
  CC: 'Cocos (Keeling) Islands',
  CK: 'Cook Islands',
  CX: 'Christmas Island',
  EH: 'Western Sahara',
  FO: 'Faroe Islands',
  GG: 'Guernsey',
  GU: 'Guam',
  IM: 'Isle of Man',
  JE: 'Jersey',
  IO: 'British Indian Ocean Territory',
  KI: 'Kiribati',
  MH: 'Marshall Islands',
  MP: 'Northern Mariana Islands',
  NF: 'Norfolk Island',
  NR: 'Nauru',
  NU: 'Niue',
  PM: 'Saint Pierre and Miquelon',
  PR: 'Puerto Rico',
  PS: 'Palestine',
  SJ: 'Svalbard and Jan Mayen',
  SS: 'South Sudan',
  TA: 'Tristan da Cunha',
  TK: 'Tokelau',
  TV: 'Tuvalu',
  VA: 'Holy See',
  VI: 'Virgin Islands',
  WF: 'Wallis and Futuna'
};
const TUI_DUTCH_LANGUAGE_CORE = {
  months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
  close: 'Sluiten',
  clear: 'Duidelijk veld',
  nothingFoundMessage: 'Niets gevonden',
  defaultErrorMessage: 'Ongeldige waarde',
  spinTexts: ['Vorige', 'Volgende'],
  shortWeekDays: ['Maa', 'Din', 'Woe', 'Don', 'Vri', 'Zat', 'Zon'],
  countries: TUI_DUTCH_LANGUAGE_COUNTRIES
};
const TUI_DUTCH_LANGUAGE_KIT = {
  cancel: 'Annuleren',
  done: 'Klaar',
  more: 'Meer',
  otherDate: 'Andere datum ...',
  showAll: 'Show all',
  hide: 'Hide',
  mobileCalendarTexts: ['Kies een dag', 'Kies bereik', 'Kies dagen'],
  range: ['van', 'tot'],
  countTexts: ['Plus', 'Min'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'dd.mm.yyyy',
    MDY: 'mm.dd.yyyy',
    YMD: 'yyyy.mm.dd'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['Toon wachtwoord', 'Wachtwoord verbergen'],
  copyTexts: ['Kopieer', 'Gekopieerd'],
  shortCalendarMonths: ['Jan', 'Feb', 'Maa', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
  pagination: ['Vorige pagina', 'Volgende pagina'],
  fileTexts: {
    loadingError: 'Error bij het laden',
    preview: 'Voorbeeld',
    remove: 'Verwijder'
  },
  inputFileTexts: {
    defaultLabelSingle: 'of zet\u00A0het\u00A0hier',
    defaultLabelMultiple: 'of zet\u00A0ze\u00A0hier',
    defaultLinkSingle: 'Kies een bestand',
    defaultLinkMultiple: 'Kies bestanden',
    maxSizeRejectionReason: 'Bestandsgrootte overschreden',
    formatRejectionReason: 'Verkeerd bestandsformaat',
    drop: 'Zet hier bestand neer',
    dropMultiple: 'Zet hier bestanden neer'
  },
  multiSelectTexts: {
    all: 'Selecteer alles',
    none: 'Selecteer geen'
  },
  confirm: {
    yes: 'Ja',
    no: 'Ingen'
  },
  previewTexts: {
    rotate: 'Draaien'
  },
  zoomTexts: {
    zoomOut: 'Uitzoomen',
    zoomIn: 'Inzoomen',
    reset: 'Opnieuw instellen'
  },
  phoneSearch: 'Indtast land eller kode'
};
const TUI_DUTCH_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_DUTCH_LANGUAGE = {
  name: 'dutch',
  ...TUI_DUTCH_LANGUAGE_CORE,
  ...TUI_DUTCH_LANGUAGE_KIT,
  ...TUI_DUTCH_LANGUAGE_ADDON_TABLE,
  ...TUI_DUTCH_LANGUAGE_ADDON_COMMERCE,
  ...TUI_DUTCH_LANGUAGE_ADDON_EDITOR,
  ...TUI_DUTCH_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_DUTCH_LANGUAGE, TUI_DUTCH_LANGUAGE_ADDON_COMMERCE, TUI_DUTCH_LANGUAGE_ADDON_EDITOR, TUI_DUTCH_LANGUAGE_ADDON_TABLE, TUI_DUTCH_LANGUAGE_CORE, TUI_DUTCH_LANGUAGE_COUNTRIES, TUI_DUTCH_LANGUAGE_KIT, TUI_DUTCH_LANGUAGE_LAYOUT };
